import React from 'react';
import PropTypes from 'prop-types';

import Button from 'react/views/generic/Button';
import './moreResults.less';


export function PreviousButton(props) {
	return <Button {...props}>Previous</Button>;
}

export function NextButton(props) {
	return <Button {...props}>Next</Button>;
}

export default function MoreResults(props) {
	let { onPrevious, onNext } = props;

	return (
		<div className="card-more-results">
			<div>
				<PreviousButton onClick={onPrevious} disabled={!onPrevious} small />
			</div>
			<NextButton onClick={onNext} disabled={!onNext} small />
		</div>
	);
}

MoreResults.propTypes = {
	/**
	 * Passed in to the next button as the onClick callback
	 * If this isn't defined then the next button is disabled
	 */
	onNext: PropTypes.func,
	/**
	 * Passed in to the previous button as the onClick callback
	 * If this isn't defined then the previous button is disabled
	 */
	onPrevious: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/react/card/MoreResults.jsx